import ExperienceCreate from './ExperienceCreate';
import ExperienceEdit from './ExperienceEdit';

export default {
  name: 'experiences',
  create: ExperienceCreate,
  edit: ExperienceEdit,
};
